import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import FloatingCTAs from "./FloatingCTAs";
import MobileBottomBar from "./MobileBottomBar";

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1" data-testid="site-main">
        <Outlet />
      </main>
      <Footer />
      <FloatingCTAs />
      <MobileBottomBar />
    </div>
  );
}
